import { Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BodyContainer, EmptyState, FilterOptionRow, OptionList } from '../../styles'

interface CheckboxFilterBodyProps {
  options: string[]
  selectedValues: string[]
  onChange: (values: string[]) => void
}

export const CheckboxFilterBody = ({ options, selectedValues, onChange }: CheckboxFilterBodyProps): ReactElement => {
  const { t } = useTranslation()

  const toggleOption = (option: string) => {
    if (selectedValues.includes(option)) {
      onChange(selectedValues.filter((value) => value !== option))
      return
    }

    onChange([...selectedValues, option])
  }

  if (options.length === 0) {
    return (
      <BodyContainer>
        <EmptyState>
          <Text variant="bodyMD">{t('review_entries.filters.no_results')}</Text>
        </EmptyState>
      </BodyContainer>
    )
  }

  return (
    <BodyContainer>
      <OptionList>
        {options.map((option) => (
          <FilterOptionRow
            checked={selectedValues.includes(option)}
            key={option}
            onChange={() => toggleOption(option)}
            size="l"
            value={option}
          >
            {option}
          </FilterOptionRow>
        ))}
      </OptionList>
    </BodyContainer>
  )
}
